import React from 'react';
import { Type, Hash, CheckCircle, Box, SquareStack, XCircle } from 'lucide-react';

export const TypeIconString: React.FC<{ className?: string }> = ({ className }) => (
  <Type className={className} />
);

export const TypeIconNumber: React.FC<{ className?: string }> = ({ className }) => (
  <Hash className={className} />
);

export const TypeIconBoolean: React.FC<{ className?: string }> = ({ className }) => (
  <CheckCircle className={className} />
);

export const TypeIconObject: React.FC<{ className?: string }> = ({ className }) => (
  <Box className={className} />
);

export const TypeIconArray: React.FC<{ className?: string }> = ({ className }) => (
  <SquareStack className={className} />
);

export const TypeIconNull: React.FC<{ className?: string }> = ({ className }) => (
  <XCircle className={className} />
);
